// extracted by mini-css-extract-plugin
module.exports = {"customSpacer":"az_Lwc"};